import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vender-signupfree',
  templateUrl: './vender-signupfree.component.html',
  styleUrls: ['./vender-signupfree.component.scss']
})
export class VenderSignupfreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
